import { Event as AdminEvent } from '@adminModels';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toAdminEvent } from '@api/adapters/event.adapter';
import { ApiConfiguration } from '@klubovna/api-client';
import { eventsControllerFindAll, EventsControllerFindAll$Params } from '@klubovna/api-client';
import { EventResponse } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PosEventsApiService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject(ApiConfiguration);

  findAll(params?: EventsControllerFindAll$Params): Observable<PaginatedResponse<AdminEvent>> {
    return eventsControllerFindAll(this.http, this.apiConfig.rootUrl, params).pipe(
      map(response => toPaginatedResponse<EventResponse>(response.body)),
      map(paginated => ({
        ...paginated,
        items: paginated.items.map(toAdminEvent),
      })),
    );
  }
}

